import { Skeleton, Typography } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import TextField from '@mui/material/TextField'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers'
import { formatDate, isValid } from 'date-fns'
import React, { FC } from 'react'
import { getPxAsRem } from 'shared/utils'
import { StyledInputLabel } from '../styled'

interface ToggleEditDatePickerProps extends DatePickerProps<Date> {
    edit: boolean
    disabled?: boolean
    loading?: boolean
    error?: boolean
    helperText?: string
    label: string
    id?: string
    format?: string
    emptyLabel?: string
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
    placeholder?: string
}

const ToggleEditDatePicker: FC<ToggleEditDatePickerProps> = ({
    edit,
    label = 'Start Date',
    onChange,
    value,
    disabled,
    loading,
    error,
    helperText,
    id,
    format = 'MM/yyyy',
    onBlur,
    emptyLabel = '-',
    ...props
}) => {
    if (loading)
        return (
            <>
                <InputLabel>{label}</InputLabel>
                <Skeleton>
                    <TextField fullWidth />
                </Skeleton>
            </>
        )
    if (edit)
        return (
            <DatePicker
                {...props}
                sx={{ width: '100%' }}
                value={value}
                format={format}
                onChange={onChange}
                label={label}
                slotProps={{
                    textField: {
                        inputProps: {
                            sx: {
                                padding: `${getPxAsRem(16, 65, 16, 12)} !important`,
                            },
                            onBlur,
                        },
                        error,
                        helperText,
                    },
                }}
            />
        )

    return (
        <>
            <StyledInputLabel>{label}</StyledInputLabel>
            <Typography variant="body1">
                {!!value && isValid(value)
                    ? formatDate(value, format)
                    : emptyLabel}
            </Typography>
        </>
    )
}

export default ToggleEditDatePicker
